var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$route.name !== "search"
        ? [_c("header-interview")]
        : [
            _c("main-header", {
              attrs: { userProfileData: _vm.userProfileData }
            })
          ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid bg-white", class: _vm.productName },
        [
          _c("router-view", { key: _vm.$route.fullPath }),
          _vm._v(" "),
          _vm.showQuoteSummaryButton
            ? _c("div", { staticClass: "quote-summary-showbtn" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary quote-summary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.showQuoteSummaryModal()
                      }
                    }
                  },
                  [
                    _vm._v("\n          Show summary  \n          "),
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "8",
                          height: "14",
                          viewBox: "0 0 8 14",
                          fill: "none"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M0.198923 7.4803L5.69901 12.9804C5.96427 13.2456 6.39433 13.2456 6.65957 12.9804L7.30106 12.3389C7.56587 12.0741 7.56638 11.6449 7.30219 11.3794L2.94328 7.00001L7.30219 2.62061C7.56638 2.35517 7.56587 1.92599 7.30106 1.66118L6.65957 1.01969C6.3943 0.754424 5.96424 0.754424 5.69901 1.01969L0.198951 6.51974C-0.0663123 6.78498 -0.0663123 7.21504 0.198923 7.4803Z",
                            fill: "#003366"
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showHideQuoteSummaryButton
            ? _c("div", { staticClass: "quote-summary-hbtn" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary quote-summary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.hideQuoteSummaryModal()
                      }
                    }
                  },
                  [
                    _vm._v("\n          Hide summary  \n          "),
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "8",
                          height: "14",
                          viewBox: "0 0 8 14",
                          fill: "none"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M7.80108 7.4803L2.30099 12.9804C2.03573 13.2456 1.60567 13.2456 1.34043 12.9804L0.698941 12.3389C0.43413 12.0741 0.433621 11.6449 0.697809 11.3794L5.05672 7.00001L0.697809 2.6206C0.433621 2.35517 0.43413 1.92599 0.698941 1.66118L1.34043 1.01969C1.6057 0.754424 2.03576 0.754424 2.30099 1.01969L7.80105 6.51974C8.06631 6.78498 8.06631 7.21504 7.80108 7.4803Z",
                            fill: "#003366"
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("main-footer", {
            staticClass: "mx-3 small",
            class: {
              "bundle-flow":
                _vm.flowType === "bundle" &&
                _vm.$router.currentRoute.path.includes("/checkout")
            },
            attrs: { id: "main-footer", role: "contentinfo" }
          }),
          _vm._v(" "),
          _c("div", [_c("quote-summary")], 1)
        ],
        1
      ),
      _vm._v(" "),
      _vm.epicSuccess
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-success alert-dismissible fade show epic-success",
              attrs: { role: "alert" }
            },
            [_vm._m(0)]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "d-inline-block float-left align-self-center mx-2 text-center"
        },
        [_c("span", { staticClass: "fas fa-check-circle epic-alert-icon" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col px-0 d-inline-block" }, [
        _c("h4", [_vm._v("Success: Customer Quote Information Imported!")]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Some customer quote information has already been imported.")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a6a8fc3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a6a8fc3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/Interview.vue
// module id = null
// module chunks = 